// Titan Theme License Validation
(function() {
  'use strict';

  // Function to get the shop domain
  function getShopDomain() {
    // First try Shopify's built-in JS variable
    if (window.Shopify?.shop) {
      return window.Shopify.shop;
    }
    
    // Try to extract from current hostname
    const hostname = window.location.hostname;
    
    // If it's a myshopify.com domain, return as-is
    if (hostname.includes('myshopify.com')) {
      return hostname;
    }
    
    // For custom domains, check if there's a meta tag with shop domain
    const shopMeta = document.querySelector('meta[name="shopify-shop-domain"]');
    if (shopMeta) {
      return shopMeta.content;
    }
    
    // Final fallback - return current hostname
    return hostname;
  }

  const CONFIG = {
    licenseKey: '',
    shopDomain: getShopDomain(),
    validationUrl: 'https://titan.gadget.app/api-verify-license',
    retryAttempts: 1,
    retryDelay: 2000
  };

  let validationInProgress = false;
  let validationResult = null;
  let isLocked = false;

  function lockTheme() {
    if (isLocked) return;
    isLocked = true;

    const overlay = document.createElement('div');
    overlay.id = 'titan-license-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, rgba(253, 24, 48, 0.95), rgba(200, 0, 72, 0.95));
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      padding: 20px;
      box-sizing: border-box;
    `;

    const message = document.createElement('div');
    message.style.cssText = `
      background: white;
      padding: 60px 50px;
      border-radius: 16px;
      max-width: 600px;
      width: 100%;
      text-align: center;
      box-shadow: 0 25px 70px rgba(0, 0, 0, 0.4), 0 10px 30px rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
    `;

    message.innerHTML = `
      <h1 style="
        margin: 0;
        font-size: 42px;
        font-weight: 700;
        color: #1a1a1a;
        letter-spacing: -0.5px;
        line-height: 1.2;
      ">
        Theme Locked
      </h1>
      <p style="
        margin: 0;
        font-size: 18px;
        color: #4a4a4a;
        line-height: 1.7;
        max-width: 500px;
      ">
        Please re-install Titan AI Store Builder or Select a Plan. If you believe this is a mistake, please contact us immediately at 
        <strong style="color: #1a1a1a;">help@titanstorebuilder.com</strong> or use the live chat.
      </p>
      <div style="margin-top: 16px;">
        <img 
          src="https://i.ibb.co/7xJ996q5/titanecom1.png" 
          alt="Titan Logo" 
          style="
            height: 40px;
            width: auto;
            opacity: 0.85;
          "
        />
      </div>
    `;

    // Add responsive styles for mobile
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 768px) {
        #titan-license-overlay > div {
          padding: 40px 30px !important;
        }
        #titan-license-overlay h1 {
          font-size: 32px !important;
        }
        #titan-license-overlay p {
          font-size: 16px !important;
        }
      }
      @media (max-width: 480px) {
        #titan-license-overlay > div {
          padding: 30px 20px !important;
        }
        #titan-license-overlay h1 {
          font-size: 28px !important;
        }
        #titan-license-overlay p {
          font-size: 15px !important;
        }
      }
    `;
    document.head.appendChild(style);

    overlay.appendChild(message);
    document.body.appendChild(overlay);
  }

  function validateLicenseWithRetry(attempt = 0) {
    return fetch(CONFIG.validationUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        shopDomain: CONFIG.shopDomain
      }),
      signal: AbortSignal.timeout(5000)
    })
    .then(response => {
      // 200 and 403 are both valid business responses
      if (response.status === 200 || response.status === 403) {
        return response.json().then(data => {
          console.log('Titan: Validation response:', data);
          return data;
        });
      }
      // Other errors should be retried
      throw new Error(`Validation failed: ${response.status}`);
    })
    .catch(error => {
      // Don't retry if exhausted or if it's a parsed response
      if (attempt >= CONFIG.retryAttempts - 1) {
        throw error;
      }
      console.log(`Titan: Validation attempt ${attempt + 1} failed, retrying...`, error.message);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(validateLicenseWithRetry(attempt + 1));
        }, CONFIG.retryDelay);
      });
    });
  }

  function validateLicense() {
    if (validationInProgress) {
      return Promise.resolve(validationResult);
    }

    if (!CONFIG.shopDomain) {
      console.log('Titan: License validation skipped - missing shop domain');
      return Promise.resolve({ isValid: true, reason: 'config_missing' });
    }

    validationInProgress = true;

    return validateLicenseWithRetry()
    .then(data => {
      validationResult = data;
      validationInProgress = false;
      
      if (data.isValid === false) {
        lockTheme();
      }
      
      return data;
    })
    .catch(error => {
      console.warn('Titan: License validation error:', error);
      validationInProgress = false;
      validationResult = { isValid: true, reason: 'validation_error' };
      return validationResult;
    });
  }

  // Initialize validation immediately on page load
  validateLicense();

  // Re-validate periodically (every 30 minutes)
  setInterval(validateLicense, 30 * 60 * 1000);

  // Re-validate when tab becomes visible (for instant unlock after re-subscribing)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      // Clear the cached validation result so it re-checks
      validationResult = null;
      validateLicense();
    }
  });

  // Also add a focus event listener as backup
  window.addEventListener('focus', function() {
    // Clear the cached validation result so it re-checks
    validationResult = null;
    validateLicense();
  });

})();
